"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderTimeLabel = exports.getOrderTimeSlotLabel = exports.isFutureOrder = exports.getScheduledTime = exports.getTimeSlot = void 0;
const date_fns_1 = require("date-fns");
const date_1 = require("./date");
const getTimeSlot = (order) => {
    return order.timeSlot !== 'immediate' ? order.timeSlot : undefined;
};
exports.getTimeSlot = getTimeSlot;
const getScheduledTime = (order) => {
    const timeSlot = (0, exports.getTimeSlot)(order);
    return timeSlot ? new Date(timeSlot.time) : undefined;
};
exports.getScheduledTime = getScheduledTime;
const isFutureOrder = (order) => {
    const scheduledOrder = (0, exports.getScheduledTime)(order);
    return scheduledOrder ? !(0, date_fns_1.isToday)(scheduledOrder) : false;
};
exports.isFutureOrder = isFutureOrder;
const getOrderTimeSlotLabel = (timeSlot, timezone) => {
    var _a;
    return (_a = timeSlot.name) !== null && _a !== void 0 ? _a : (0, date_1.formatInTimeZone)(new Date(timeSlot.time), 'genericTimeFormat', timezone);
};
exports.getOrderTimeSlotLabel = getOrderTimeSlotLabel;
const getOrderTimeLabel = (orderTime, timezone) => {
    if (orderTime === 'immediate') {
        return 'Immediate';
    }
    else if (orderTime) {
        return (0, exports.getOrderTimeSlotLabel)(orderTime, timezone);
    }
};
exports.getOrderTimeLabel = getOrderTimeLabel;
//# sourceMappingURL=timeSlot.js.map